import { useState } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import { getMUICache, appendStyleSheet, handleSearchClick, fetchAnchorValue } from "../../../common/utils"
import { CacheProvider } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// import { Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import "./MainMenuTwo.css";
import HomeIcon from '@mui/icons-material/Home';
import { ENDUSER_PAGE } from '../../Common/Constant';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import bcrypt from 'bcryptjs-react';


MainMenuTwo.version = 1000;

MainMenuTwo.lang = 'en';
MainMenuTwo.langs = [
  'en'
];
MainMenuTwo.setLang = (lang: any) => {
  MainMenuTwo.lang = lang;
}

Object.defineProperty(MainMenuTwo, 'name', {
  writable: true,
  value: 'MainMenuTwo'
});

export default function MainMenuTwo(props: any) {

  // console.log("Inside MainMenuTwo props", props);

  const { menuItems, domainUrl, toggleMainMenu, headerMenuEndpoint, cdsDomain, L1BgColor, L1TextColor, L2BgColor, L2TextColor, showSearch, noOfHeaderItems, hostId, anchorLinksValue, HamburgerIconColor, SearchIconColor, groupMenuItems } = props;

  const [SearchBar, setSearchBar] = useState<any>(false);
  const [Closebtn, setClosebtn] = useState<any>(false);
  const [isActive, setIsActive] = useState<any>(false);
  const [searchValue, setSearchValue] = useState<any>("");
  const chunkArray = (arr: any[], size: number): any[][] => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  let styles = require("./MainMenuTwo.css");
  appendStyleSheet("MainMenuTwo", styles);


  const getUrl = (domainUrl: string, path: string) => {
    if (!domainUrl) { return }
    let updatedDomain = domainUrl;
    if (domainUrl.length > 0 && domainUrl[domainUrl.length - 1] == "/") {
      updatedDomain = domainUrl.substring(0, domainUrl.length - 1)
    }

    if (path.includes("http://") || path.includes("https://")) {
      updatedDomain = path;
    } else {
      updatedDomain = updatedDomain + path;
    }

    return updatedDomain;
  }

  const getSubMenu = (subMenuItems: any) => {
    return <div className="submenuItems bb" style={{ backgroundColor: L2BgColor }}>
      {
        subMenuItems.map((subMenuItem: any, index: number) => {
          let submenuPath = subMenuItem?.path;
          if (subMenuItem?.type === 2) {
            submenuPath = '/tags/' + (subMenuItem?.tagpath !== undefined ? subMenuItem?.tagpath : '');
          }
          return <div className='subMenuli' key={'mmi__' + index} itemProp="name" content={subMenuItem?.name}>
            <a key={'mmia__' + index} href={getUrl(domainUrl, submenuPath)} itemProp="url" content={getUrl(domainUrl, submenuPath)} target={fetchAnchorValue(anchorLinksValue, submenuPath)} style={{ color: L2TextColor }}>
              {subMenuItem?.name}
            </a>
          </div>
        }
        )
      }
    </div>
  }
  const showSearchBar = () => {
    setSearchBar(true)
    setClosebtn(true)
  }
  const closehandler = () => {
    setSearchBar(false)
    setClosebtn(false)
  }
  const renderMoreOption = () => {
    if (!groupMenuItems) {
      console.log("groupMenuItems is falsy:", groupMenuItems);
      return null;
    }
    let optionData = menuItems?.slice(noOfHeaderItems, menuItems.length);
    if (!optionData || optionData.length === 0) {
      console.log("optionData is empty:", optionData);
      return null;
    }

    return (
      <li className="nav-item hideMoreMobile mega-menu-parent">
        <ListItemButton
          key="explore"
          component="a"
          className="has-submenu"
          style={{ color: L1TextColor, cursor: "pointer" }}
        >
          {groupMenuItems}
        </ListItemButton>
        <div className="mega-menu-submenu" style={{ backgroundColor: L2BgColor }}>
          <ul className="submenu mega-menu-columns" style={{ backgroundColor: L2BgColor }}>
            {optionData.map((menuItem: any, idx: number) => {
              const subMenuChunks = chunkArray(menuItem.sections || [], 6);
              const flexBasisPercent = subMenuChunks.length > 0 ? Math.min(subMenuChunks.length * 18, 100) : 18;
               let morePath = menuItem?.path;

              return (
                <li className="submenu-item mega-menu-col" key={menuItem.name + idx}
                  style={{ "--col-flex-basis": `${flexBasisPercent}%` } as React.CSSProperties} >
                  <a className="mega-menu-section-title"  href={getUrl(domainUrl, morePath)} target={fetchAnchorValue(anchorLinksValue, morePath)} content={getUrl(domainUrl, morePath)} style={{ color: L2TextColor }}>
                    {menuItem.name}
                  </a>
                  <div className="moreSubmenuWrapper">
                    {subMenuChunks.map((subGroup, groupIdx) => (
                      <div className="subMenuli-column" key={groupIdx}>
                        {subGroup.map((section: any, sidx: number) => {
                          let sectionPath = section?.path;
                          if (section?.type === 2) {
                            sectionPath = '/tags/' + (section?.tagpath ?? '');
                          }
                          return (
                            <div className="subMenuli" key={section.name + sidx} itemProp="name"content={section?.name}>
                              <a
                                href={getUrl(domainUrl, sectionPath)}
                                target={fetchAnchorValue(anchorLinksValue, sectionPath)}
                                style={{ color: L2TextColor }}
                                itemProp="url"
                                content={getUrl(domainUrl, sectionPath)}
                              >
                                {section.name}
                              </a>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                </li>
              );
            })}

          </ul>
        </div>

      </li>
    );
  };

  const checkIfActive = (name: string) => {

    if (typeof window !== 'undefined' && window && window.location && window.location.pathname) {
      const pathName = window.location.pathname.toLowerCase();
      const nameLowerCase = name?.toString()?.toLowerCase();

      if (pathName.indexOf("/" + nameLowerCase + "/") >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const getMenuData = () => {
    if (!Array.isArray(menuItems)) {
      console.error('menuItems is not an array or is undefined');
      return [];
    }

    let menuData = menuItems.slice(0, noOfHeaderItems);
    let moreOption;

    if (menuData.length > 0 && menuData.some((item) => item.secid === '123')) {
      if (typeof window !== 'undefined') {
        const { pathname } = window.location;
        const splitPath = pathname.split('/');
        const secondLastSegment = splitPath[splitPath.length - 2];
        if (ENDUSER_PAGE.includes(secondLastSegment)) {
          callNavApi(menuData, headerMenuEndpoint.queryParams.hostId);
          menuData = menuData.map((item) => {
            if (item.secid === '123') {
              return { ...item, name: <HomeIcon />, key: 123 };
            }
            return item;
          });
        }
      }
    }

    let data = menuData.map((menuItem, index) => {
      if (menuItem) {
        let isActive = checkIfActive(menuItem?.name);
        let morePath = menuItem?.path;
        if (menuItem?.type === 2) {
          morePath = '/tags/' + (menuItem?.tagpath !== undefined ? menuItem?.tagpath : '');
        }
        return (
          <ListItem key={'kk_' + index} className={`menuItem ${isActive ? 'active' : ''}`} itemProp="name" content={menuItem.name}>
            <div key={'00_' + index}>
              <ListItemButton key={'111_' + index} component="a" href={getUrl(domainUrl, morePath)} target={fetchAnchorValue(anchorLinksValue, morePath)} style={{ color: L1TextColor }} itemProp="url" content={getUrl(domainUrl, morePath)}>
                {menuItem.name}
              </ListItemButton>
              {menuItem?.sections && menuItem?.sections.length > 0 && getSubMenu(menuItem?.sections)}
            </div>
          </ListItem>
        );
      }
      return null;
    });

    if (menuItems.length > noOfHeaderItems && groupMenuItems) {
      moreOption = renderMoreOption();
      return [...data, moreOption];
    }

    return data;
  }

  function callNavApi(menuData: any, hostId: any) {
    if (typeof window !== 'undefined' && undefined !== window && window) {
      const pathName = window.location.pathname;
      const pathArray = pathName.split('/');
      let msid = pathArray[pathArray.length - 1];
      msid = msid.split('.')[0];
      const url = `${cdsDomain}/cds-feed-ext/listing/get/m360?msid=${msid}&fv=1000&hostId=${hostId}&pp=4&cp=1&apiType=nav`;

      let headerString = '?' + url.split("?")[1];
      headerString = bcrypt.hashSync(headerString, 6);
      const headers = { 'p-nonce': headerString };

      const fetch1 = require('sync-fetch');
      const pr = fetch1(url, { headers: headers });
      const statusCode = pr.status;
      let response = [];
      try {
        response = pr.json();
      } catch (error: any) {
        console.error('Error:', error.message);
      }
      if (statusCode === 200) {
        if (response) {
          const firstElement = response.items[0];
          let item = null;
          if (pathArray.includes('articleshow')) {
            item = { name: firstElement.hl, secid: '456', path: firstElement.wu, type: 1 }
          } else if (pathArray.includes('articlelist')) {
            item = { name: response.title, secid: '456', path: pathName, type: 1 }
          }
          //menuData.unshift(item);
          menuData.splice(1, 0, item);
        }
      }
    }
  }

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission or new window/popup
      handleSearchClick(searchValue, hostId); // Call your search handling function
    }
  }

  return (
    <CacheProvider value={getMUICache()}>
      <div className='themeTwoMainMenuWrap' style={{ backgroundColor: L1BgColor }}>
        <Box sx={{ minHeight: 19 }} className="themeTwoMainMenu">
          <div className='navbar' style={{ backgroundColor: L1BgColor }}>
            <List orientation="horizontal"
              sx={{
                '--List-padding': '4px',
                '--List-gap': '0px',
                '--ListItem-paddingX': '7px',
                '--ListItem-paddingY': '0px',
                padding: "0px"
              }}
              itemType="http://www.schema.org/SiteNavigationElement"
              itemScope={true}
            >
              <div className="sidebar-menu-icon desktoThemeTwohamburger" onClick={() => { toggleMainMenu(); toggleClass(); }}>
                <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} className={isActive ? 'hamburgerActiveClass' : 'hamburgerInactiveClass'}>
                  <MenuIcon style={{ color: HamburgerIconColor }} className='acfr' />

                </IconButton>
              </div>

              {getMenuData()}

              {showSearch && <div className='themeTwoSearchIcon'>
                {!Closebtn && <SearchIcon onClick={() => showSearchBar()} style={{ color: SearchIconColor }} />}
                {Closebtn && <CloseIcon onClick={() => closehandler()} style={{ color: SearchIconColor }} />}

                {(showSearch && SearchBar) &&
                  <div className='themeSearchMainWrap'>
                    <div className="search-main">
                      <div className="search" >
                        <TextField
                          id=""
                          placeholder='Search'
                          type='text'
                          onKeyPress={(e) => handleKeyPress(e)}
                          onChange={e => setSearchValue(e.target.value)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <SearchIcon onClick={() => handleSearchClick(searchValue, hostId)} />
                              </InputAdornment>
                            )
                          }}
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>}
            </List>

          </div>
        </Box>
      </div>
    </CacheProvider>
  );
}
